<template>
  <div>
    <div class="col-sm-3 lessdzheight">
      <div class="thumbnail" style="margin-top: 0;" v-if="object.logo">
        <div class="thumb">
          <a class="logo-image" :href="object.logo.fullscale" data-popup="lightbox">
            <img v-if="object.logo.is_public" :src="object.logo.preview" alt="logo"/>
            <img v-if="!object.logo.is_public" v-auth-img="object.logo.preview" alt="logo"/>
          </a>
          <div class="caption-overflow">
            <span>
              <a href="javascript: void(0);" class="btn btn-info btn-sm" @click="removeLogo()">Remove</a>
            </span>
          </div>
        </div>
      </div>
      <div v-else>
        <UploadForm :dropzone="true" accept="image/*" @uploadStarted="uploadStarted" @uploadComplete="uploadComplete" @uploadError="uploadError"></UploadForm>
      </div>
    </div>
    <div class="col-sm-9">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" :class="{'has-error': errors.has('agentForm.first_name') }">
            <label class="control-label" v-if="showLabels">First name</label>
            <input type="text" data-vv-scope="agentForm" data-vv-name="first_name" v-model="object.first_name" v-validate="" :placeholder="showLabels ? '' : 'First name'" class="form-control" :title="errors.first('agentForm.first_name')"/>
            <div class="form-control-feedback" v-if="errors.has('agentForm.first_name')">
              <i class="icon-cancel-circle2"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group" :class="{'has-error': errors.has('agentForm.last_name') }">
            <label class="control-label" v-if="showLabels">Last name</label>
            <input type="text" data-vv-scope="agentForm" data-vv-name="last_name" v-model="object.last_name" v-validate="" :placeholder="showLabels ? '' : 'Last name'" class="form-control" :title="errors.first('agentForm.last_name')"/>
            <div class="form-control-feedback" v-if="errors.has('agentForm.last_name')">
              <i class="icon-cancel-circle2"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" :class="{'has-error': errors.has('agentForm.email') }">
            <label class="control-label" v-if="showLabels">Email</label>
            <input type="text" data-vv-scope="agentForm" data-vv-name="email" v-model="object.email" v-validate="" :placeholder="showLabels ? '' : 'Email'" class="form-control" :title="errors.first('agentForm.email')"/>
            <div class="form-control-feedback" v-if="errors.has('agentForm.email')">
              <i class="icon-cancel-circle2"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group" :class="{'has-error': errors.has('agentForm.phone') }">
            <label class="control-label" v-if="showLabels">Phone</label>
            <input type="text" data-vv-scope="agentForm" data-vv-name="phone" v-model="object.phone" v-validate="" :placeholder="showLabels ? '' : 'Phone'" class="form-control" :title="errors.first('agentForm.phone')"/>
            <div class="form-control-feedback" v-if="errors.has('agentForm.phone')">
              <i class="icon-cancel-circle2"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="pull-right">
        <button @click.prevent="saveData()" :class="{'disabled': mode.disabled}" class="btn btn-success">Add agent</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import UploadForm from '@/components/_partial/UploadForm'

import AgencyService from '@/services/agency.service'
import UserService from '@/services/user.service'

import validateMixin from '@/helpers/mixins/_validateMixin'

export default {
  name: 'AgencyAgentForm',
  components: { UploadForm },
  mixins: [validateMixin],

  props: {
    'parent': {
      type: Object
    },
    'entity': {
      type: Object
    },
    'showLabels': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      object: {},
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: AgencyService,
      services: {
        'user': UserService
      },
      statuses: [],
      systemStatuses: [],
      mode: {
        statusMap: {},
        resetAfterMount: false,
        disabled: false
      },
      /** **/
      objectState: {},
      /** **/
      drawComponent: true
    }
  },

  computed: {},

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.statuses = []
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    // let promises = []
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    flushObjectIfRequired () {
      console.log(this.$route)
      this.$emit('shown', this.object)
      this.hardReset()
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
    },

    refresh (newInstance) {
      this.$emit('shown', this.object)
    },

    setItemStatus (item, status) {
      this.service.update(item, {
        'id': item,
        'status': status
      }, result => {
        this.service.item(result.id).then(newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true

      this.objectState = Object.assign({}, this.object)
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true

      this.object = this.objectState
      this.$forceUpdate()
    },

    saveData () {
      if (this.mode.disabled) {
        return
      }
      this.services['user'].create(this.prepareData(this.object), (result) => {
        this.object = {}
        this.service.addAgent(this.parent.id, result.id, (result) => {
          console.log('Agent added', result)
          this.$emit('item:added', true)
        })
      }, (error) => {
        if (Array.isArray(error.body)) {
          for (let e in error.body) {
            this.addError(error.body[e], 'agentForm')
          }
        }
      })
    },

    prepareData (obj) {
      let result = null
      result = {
        first_name: obj.first_name,
        last_name: obj.last_name,
        email: obj.email,
        phone: obj.phone,
        //
        agency_id: this.parent.id,
        isIndividual: true,
        //
        logo_image_id: obj.logo_image_id
      }
      return result
    },

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
    },

    /** action methods **/
    setLogo (image) {
      this.object = Object.assign(this.object, {
        logo: image || null
      })
      this.object.logo_image_id = image.id || null
      this.$forceUpdate()
    },

    removeLogo () {
      this.object.logo = null
      this.object.logo_image_id = null
      this.$forceUpdate()
    },

    uploadComplete (file) {
      this.mode.disabled = false
      this.$logger.log('uploadComplete', file)
      this.setLogo(file.uploaded.image || null)
    },

    uploadStarted (file) {
      this.$logger.log('uploadStarted', file)
      this.mode.disabled = true
    },

    uploadError (file) {
      this.mode.disabled = false
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    }

    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>
.logo-image img {
  max-height: 112px;
  min-height: 112px;
  max-width: 100%;
  width: auto;
}
</style>
